module.exports = __webpack_public_path__ + "img/logo_equinsa_networking.6059c998.png";